/* src/app/acs-chat/components/chat-window/chat-window.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.chat-window {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.chat-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  min-height: 54px;
}
.back-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #5ba4b5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover {
  background: #4a8d9e;
}
.header-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #7b8a9e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
.header-title {
  font-weight: 700;
  font-size: 18px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header-badge {
  background: #e74c3c;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
}
.header-spacer {
  flex: 1;
}
.compose-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  transition: transform 0.15s;
}
.compose-btn:hover {
  transform: scale(1.1);
}
.chat-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
/*# sourceMappingURL=chat-window.css.map */
